<template>
  <div>
    <b-nav-item-dropdown
      right
      toggle-class="d-flex align-items-center dropdown-user-link"
      class="dropdown-user"
    >
      <template #button-content v-if="Object.keys(userData).length > 0">
        <div class="d-sm-flex d-none user-nav">
          <p class="user-name font-weight-bolder mb-0">
            {{
              userData.firstName + " " + userData.lastName || userData.username
            }}
          </p>
        </div>
        <b-avatar
          size="40"
          :src="userData.avatar"
          variant="light-primary"
          badge
          class="badge-minimal"
          badge-variant="success"
        >
          <feather-icon v-if="!userData.fullName" icon="UserIcon" size="22" />
        </b-avatar>
      </template>

      <b-dropdown-item
        :to="{ name: 'pages-profile' }"
        link-class="d-flex align-items-center"
      >
        <feather-icon size="16" icon="UserIcon" class="mr-50" />
        <span>Profile</span>
      </b-dropdown-item>
      <b-dropdown-item
        :to="{ name: 'accountManagement-change-password' }"
        link-class="d-flex align-items-center"
      >
        <feather-icon size="16" icon="LockIcon" class="mr-50" />
        <span>Change Pass</span>
      </b-dropdown-item>
      <b-dropdown-divider />
      <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
        <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
        <span>Logout</span>
      </b-dropdown-item></b-nav-item-dropdown
    >
    <b-overlay
      class="d-flex justify-content-center"
      :show="isLoading"
      no-wrap
      rounded="sm"
    >
      <template #overlay>
        <div id="loading-bg">
          <div class="loading-logo">
            <img src="../../../../../../public/logo.png" alt="Please Wait..." />
          </div>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import {
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
  BOverlay,
} from "bootstrap-vue";
import { avatarText } from "@core/utils/filter";
import axios from "@axios";
import { setUnauthenticated } from "@/router";
export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    BOverlay,
  },
  data() {
    return {
      avatarText,
      isLoading: false,
    };
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    logout() {
      this.isLoading = true;
      axios
        .get("User/api/V1.0/Account/LogOut")
        .then((res) => {
          // Reset ability
          // Redirect to login page
          this.$store.dispatch("permission/handleLogout");
          setUnauthenticated();
          this.$router.push({ name: "auth-login" });
          this.isLoading = false;
        })
        .catch((res) => {
          this.isLoading = false;
          console.log(res);
        });
      // Reset ability
    },
  },
};
</script>
